import React from 'react';
import './style.scss';
import {
    FacebookShareButton,
    TwitterShareButton,
    TelegramShareButton,
    ViberShareButton
} from "react-share";
import { useLocation } from "react-router-dom";
import { URL } from '../../utils/constants';

export const ShareList = ({ customUrl, theme = 'default' }) => {

    const location = useLocation();
    const url = customUrl ? `${URL}${customUrl}` : `${URL}${location.pathname}`;
    const title = 'Мені здається - анонімний онлайн-щоденник';

    return (
        <div className = 'share-list'>

            <FacebookShareButton
                //hashtag = '#camperstribe'
                className = 'share-wrap'
                quote = { title }
                url = { url }>
                <div className = { `share share-${theme} share-fb` }>
                    <i className = 'icon icon-facebook' />
                </div>
            </FacebookShareButton>

            <TelegramShareButton
                className = 'share-wrap'
                title = { title }
                //hashtag="#camperstribe"
                url = { url }>
                <div className = { `share share-${theme} share-tg` }>
                    <i className = 'icon icon-telegram' />
                </div>
            </TelegramShareButton>

            <TwitterShareButton
                className = 'share-wrap'
                title = { title }
                //hashtag="#camperstribe"
                url = { url }>
                <div className = { `share share-${theme} share-tw` }>
                    <i className = 'icon icon-twitter' />
                </div>
            </TwitterShareButton>

            <ViberShareButton
                className = 'share-wrap'
                title = { title }
                //hashtag="#camperstribe"
                url = { url }>
                <div className = { `share share-${theme} share-vb` }>
                    <i className = 'icon icon-viber' />
                </div>
            </ViberShareButton>
        </div>
    );
};

/*
export const ShareList = ({ test, customUrl }) => {

    const [mt, setMt] = useState(false);
    const location = useLocation();
    const url = customUrl ? customUrl : `${URL}${location.pathname}/`;

    return (
        <div className = 'share-list'>
            <a
                onClick = { (event) => {
                    event.preventDefault();
                    if (test) {
                        setMt(true);
                        console.log('click');
                    }
                } }>
                <TelegramShareButton
                    className = 'share'
                    //title = { "Мені здається - анонімний онлайн-щоденник" }
                    //hashtag="#camperstribe"
                    url = { url }>
                    <TelegramIcon round bgStyle = { { fill: '#F0F0F0' } } iconFillColor = '#46435a' size = { 48 } />
                </TelegramShareButton>
            </a>
            <a
                className = 'share'
                onClick = { (event) => {
                    event.preventDefault();
                    if (test) {
                        setMt(true);
                        console.log('click');
                    }
                } }>
                <FacebookShareButton
                    className = 'share'
                    //hashtag = '#camperstribe'
                    //quote = { "Мені здається - анонімний онлайн-щоденник" }
                    url = { url }>
                    <FacebookIcon round bgStyle = { { fill: '#F0F0F0' } } iconFillColor = '#46435a' size = { 48 } />
                </FacebookShareButton>
            </a>
            <a
                onClick = { (event) => {
                    event.preventDefault();
                    if (test) {
                        setMt(true);
                        console.log('click');
                    }
                } }>
                <TwitterShareButton
                    className = 'share'
                    //title = { "Мені здається - анонімний онлайн-щоденник" }
                    //hashtag="#camperstribe"
                    url = { url }>
                    <TwitterIcon round bgStyle = { { fill: '#F0F0F0' } } iconFillColor = '#46435a' size = { 48 } />
                </TwitterShareButton>
            </a>

            {/!*            <button
                className = 'share'
                title = 'facebook'>
                <img
                    alt = 'facebook'
                    src = { facebookSvg }
                />
            </button>
            <button
                className = 'share'
                title = 'telegram'>
                <img
                    alt = 'telegram'
                    src = { telegramSvg }
                />
            </button>
            <button
                className = 'share'
                target = '_blank'
                title = 'instagram'>
                <img
                    alt = 'instagram'
                    src = { instagramSvg }
                />
            </button>
            <button
                className = 'share'
                title = 'viber'>
                <img alt = 'viber' src = { viberSvg } />
            </button>*!/}
{
    mt ?
        <HelmetMetaData
            description = 'Мій чоловік не був нелюдом, він - прекрасний батько, хороший син, гарний керівник, і добрий друг. А мене бив.
І кожного разу вибачався.
Сам плакав, клявся, що більше ніколи й пальцем мене троне. І я вірила кожного разу.
 А якщо і не вірила, то питала в себе: куди я піду, де буду жити з дітьми, де буду працювати, брати гроші, як буду допомагати старим батькам. Останнього разу він проломив мені череп. Тоді я зрозуміла, що це має закінчитись. В лікарні я нічого нікому не сказала, бо я навіть не знаю, як це вимовити, мені ніхто не повірить - він же ідеальний, і родина у нас ідеальна. Після виписки я зібрала речі, взяла дітей і переїхала до подружки. Він приїздив, благав, обіцяв золоті гори, потім став погрожувати, що забере дітей, і, що врешті-решт вб’є мене. І зараз у моєї історії немає фіналу, бо він подав до суду на позбавлення мене батьківських прав, у нього є гроші і зв’язки, а я живу у подруги, маю стареньку маму (батько помер місяць тому), двох дітей і не знаю, як жити далі.'
            title = 'Я терпіла побиття 7 років, не знаю, як жити далі'
            type = 'article'
        />
        :
        null
}
</div>
);
}; */
